import { useState, useEffect } from 'react';
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Icons
import { IoMdSettings } from "react-icons/io";
import { FaTrashAlt } from "react-icons/fa";

const PromotionCardComponent = ({ id, promotion, handleEditPromotionItem, handleDeletePromotionItem, totalItems }) => {

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    width: 256,
    height: 286,
    margin: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    overflow : 'hidden',
    cursor: "grab",
    transform: CSS.Transform.toString(transform),
    transition,
  };


  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div style={{ flexDirection : 'column' }}>
      <img style={{ height : 256, objectFit : 'cover', display: 'block', width : '100%' }} src={ promotion.imageUrl } />
      <div style={{ height : 30, backgroundColor : '#8d949e', paddingLeft: 10, paddingRight : 10, display : 'flex', alignItems : 'center', justifyContent : 'space-between', width : '100%' }}>
        <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center' }}>
          <div style={{ color : 'white', fontSize: 16, fontWeight : 'normal' }}># { (parseInt(promotion.orderId)+1) } / { totalItems }</div>
          <div style={{ marginLeft: 5, color : 'white', fontSize: 16, fontWeight : 'bold' }}>{ promotion.enrichedData.displayStatus }</div>
        </div>
          
        <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center', marginTop : -5 }}>
          <div style={{ cursor : 'pointer' }} onClick={ () => { handleEditPromotionItem(promotion); }}><IoMdSettings style={{ color : 'white', fontSize: 26, paddingTop : 4 }} /></div>
          <div style={{ cursor : 'pointer' }} onClick={ () => { handleDeletePromotionItem(promotion); }}><FaTrashAlt style={{ color : 'white', fontSize: 22, paddingTop : 4 }} /></div>
        </div>
      </div>
      </div>
    </div>
  );

  /**
  return (
    <div ref={ setNodeRef } style={ style } {...attributes} {...listeners}>
      <div style={{}}>
        <img style={{ height : 100 }} src={ promotion.imageUrl } />
        { promotion.displayText ? (
          <div style={{}}>{ promotion.displayText }</div>
        ) : null }
      </div>
      <div style={{}}>
        <div style={{ color : 'white', fontSize: 18, fontWeight : 'bold' }}>{ promotion.enrichedData.displayStatus }</div>
        <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center' }}>
          <div style={{ cursor : 'pointer' }} onClick={ () => { handleEditWebstoreLinkItem(promotion); }}><IoMdSettings style={{ color : 'white', fontSize: 26, paddingTop : 4 }} /></div>
          <div style={{ cursor : 'pointer' }} onClick={ () => { handleDeleteWebstoreLinkItem(promotion); }}><FaTrashAlt style={{ color : 'white', fontSize: 22, paddingTop : 4 }} /></div>
        </div>
      </div>
    </div>
  );
  **/

};

export default PromotionCardComponent;

